import HearingSummary from 'components/HearingSummary'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { hearingSummaryInit, HearingSummaryType } from 'types/hearing-summary.type'
import summaryService from '../../../../services/summary.service'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { useBackdrop } from 'contexts/backdrop.context'
import { useSnackBar } from 'contexts/snackbar.context'
import { SystemMessages } from 'utils/enums/system-message.enum'
import DialogAlert from 'components/Dialog/Alert'
import { Stack } from '@mui/material'
import Label from 'components/Label'
import { HttpErrorType } from 'types/http.type'
import { errorColor, errorMessage } from 'utils/error.util'
import { OutletContextType } from 'pages/CreateHearing'
import { StepIndex } from 'pages/CreateHearing/enums/step.enum'
import { StyledPrintContent } from 'pages/DownloadHearing'

export const StepSummaryPage: React.FC = () => {
  const navigate = useNavigate()

  const { id } = useParams()
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()
  const { showSnackBar } = useSnackBar()
  const { formRefs } = useOutletContext<OutletContextType>()

  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [openDialogError, setOpenDialogError] = useState<boolean>(false)

  const [summary, setSummary] = useState<HearingSummaryType>(hearingSummaryInit)
  const [fieldErrors, setFieldErrors] = useState<string[]>([])

  const getSummary = useCallback(async () => {
    handleBackdropOpen()
    await summaryService
      .getById(id)
      .then((response) => {
        if (response.data) setSummary(response.data)
      })
      .finally(() => handleBackdropClose())
  }, [id])

  useEffect(() => {
    getSummary()
  }, [getSummary])

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const handleOpenErrorModal = () => {
    setOpenDialogError(true)
  }

  const handleCloseErrorDialog = () => {
    setOpenDialogError(false)
  }

  const handleDownloadNavigation = () => {
    navigate(`/download-oitiva/${id}`)
  }

  const saveSummary = async (): Promise<void> => {
    if (id) {
      handleCloseDialog()
      handleBackdropOpen()
      await summaryService
        .save(id)
        .then((res) => {
          if (res.data.errors && res.data.errors.length > 0) {
            setFieldErrors(res.data.errors)
            handleOpenErrorModal()
          } else {
            showSnackBar('Finalizada.', 'success')
            handleDownloadNavigation()
          }
        })
        .catch((error: HttpErrorType) => {
          showSnackBar(errorMessage(error), errorColor(error))
        })
        .finally(() => handleBackdropClose())
    }
  }

  formRefs.current[StepIndex.RESUMO_OITIVA] = {
    submit: async () => {
      handleOpenDialog()
      return Promise.resolve()
    },
  }

  const componentRef = useRef(null)

  return (
    <>
      <StyledPrintContent ref={componentRef}>
        <div className='print__wrapper--outter'>
          <div className='content__wrapper print__wrapper'>
            <HearingSummary data={summary} />
          </div>
        </div>
      </StyledPrintContent>

      <DialogAlert
        title=''
        contentText={SystemMessages.MESSAGE_009}
        open={openDialog}
        onSuccess={() => saveSummary()}
        onClose={handleCloseDialog}
      />

      <DialogAlert
        title=''
        content={
          <Stack direction='column' spacing={1}>
            <Label text='Para finalizar é necessário informar os seguintes campos: ' bold />
            {fieldErrors && fieldErrors.map((item, i) => <div key={i}>{item}</div>)}
          </Stack>
        }
        open={openDialogError}
        onClose={handleCloseErrorDialog}
        buttonCloseText='Fechar'
      />
    </>
  )
}
